// Fetch a calendar events from an api defined endpoint
import throttle from 'lodash/throttle';
import { fetchCalendarEvents } from '@/components/date/api';
import moment from 'moment';

export default {
  inject: {
    $getParentEditor: {
      default: null,
    },
  },
  props: {
    label: {
      type: String,
    },
    calendarEventsEndpoint: {
      type: String,
    },
  },
  data() {
    return {
      events: null,
      eventsColor: null,
    };
  },
  computed: {
    eventsEndpointURL() {
      if (!this.calendarEventsEndpoint) {
        return null;
      }
      try {
        return new URL(this.calendarEventsEndpoint, document.location.origin);
      } catch (error) {
        console.error(`calendarEventsEndpoint prop needs a valid url '${this.calendarEventsEndpoint}' at ${this.label} component`, error);
        return null;
      }
    },
  },
  methods: {
    // Vuetify doesn't support calendar events on month change :-(
    // we use the formatDay function to add a listener to the month change event
    formatDay(value) {
      const [year, month, date] = value.split('-');
      if (this.eventsEndpointURL) {
        this.throttledFetchCalendarEvents(year, month);
      }
      return Number.parseInt(date, 10);
    },
    async loadCalendarEvents(year, month) {
      const { color, events } = await fetchCalendarEvents(
        this.eventsEndpointURL.href,
        Number.parseInt(year, 10),
        Number.parseInt(month, 10),
      );
      this.eventsColor = color;
      this.events = events;
    },
  },
  mounted() {
    if (this.eventsEndpointURL) {
      this.throttledFetchCalendarEvents = throttle(this.loadCalendarEvents, 300, { trailing: false });
      const currentDate = this.value ? moment(this.value) : moment();
      this.loadCalendarEvents(currentDate.year(), currentDate.month() + 1);
    }
  },
};
